export default "__VITE_ASSET__06ea490c__"